jQuery(function($){
	//Change array group title if empty when voice part updated
	$('.sc-field-editor .field.array .learning_tracks').on('change', '.field.select select.part', function(){
		let titleInput = $(this).closest('.array-field-info').find('input.title');
		if(titleInput.val() == '') titleInput.val($(this).find('option:selected').html()).trigger('change');
	});
});